import { useContext, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { FRANCHISE_INFO_LIST } from '~/components/FranchiseInfoCard/index';
import { useModal } from '~/composables';
export default defineComponent({
    name: 'FranchiseInfoCard',
    props: {
        article: {
            default: () => ({}),
            type: Object,
        },
        schemaDisabled: {
            default: false,
            type: Boolean,
        },
    },
    setup(props) {
        const context = useContext();
        const css = useCssModule();
        const modal = useModal();
        const ym = context.$yandexMetrika;
        function handleClick() {
            ym.reachGoal('send_katalog');
            modal.open('franchiseRequest', {
                componentAttrs: {
                    articleId: props.article.id,
                },
            });
        }
        return {
            FRANCHISE_INFO_LIST,
            css,
            handleClick,
        };
    },
});
